/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMinus: {
  name: 'minus';
  data: string;
} = {
  name: 'minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
